__turbopack_context__.v({
  "button": "styles-module-scss-module__kbiVFG__button",
  "root": "styles-module-scss-module__kbiVFG__root",
});
